import { t } from '@vitesse/base-ui/i18n';
import { statusColor } from '@vitesse/base-ui/components/templates';
import type { ModelStatus } from '../../../core/domain/model';

/*
 * Shared model-status presentation — one place that maps a ModelStatus to its
 * badge color + i18n label, used by the card, the detail header, and any
 * section/widget that shows model status. (statusColor is reused from the
 * shared templates so model + controller status badges stay consistent.)
 */
export { statusColor };

/** i18n label for a model runtime status (kept as a switch so t() sees literal keys). */
export function modelStatusLabel(s: ModelStatus): string {
  switch (s) {
    case 'running':
      return t('model.statusRunning');
    case 'stopped':
      return t('model.statusStopped');
    case 'waiting':
      return t('model.statusWaiting');
    case 'starting':
      return t('model.statusStarting');
    case 'paused':
      return t('model.statusPaused');
    case 'error':
      return t('model.statusError');
    default:
      return t('model.statusUnknown');
  }
}

/** True when the model is in a live/active phase (drives stop-vs-start, pause-enable). */
export function isModelActive(s: ModelStatus): boolean {
  return s === 'running' || s === 'waiting' || s === 'starting' || s === 'paused';
}
